import React from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import PropTypes from 'prop-types';
const Official = ({ officialList }) => {

  return (
    <div className=''>
      <div className="overflow-x-auto max-w-[472px]">
        <div className="w-[472px] flex">
          <div className="max-w-[115px] min-w-[115px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#7D7D7D] bg-white border-[1px] border-[#E8E8E8] rounded-tl-md">
            Code
          </div>
          <div className="max-w-[115px] min-w-[115px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#7D7D7D] bg-white border-[1px] border-[#E8E8E8] border-l-0 ">
            Role
          </div>

          <div className="max-w-[215px] min-w-[215px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#7D7D7D] border-l-0 bg-white border-[1px] border-[#E8E8E8] rounded-tr-md">
            Team
          </div>
        </div>

        {officialList && officialList.map((data) => (
          <div key={data?.code} className="w-[472px] flex   ">
            <div className="max-w-[115px] min-w-[115px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#4A4A4A] bg-white border-[1px] border-[#E8E8E8] rounded-bl-md">
              {data?.code}
            </div>
            <div className="max-w-[115px] min-w-[115px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#4A4A4A] bg-transparent border-[1px] border-[#E8E8E8] border-l-0">
              {data?.officials[0]?.official_name}
            </div>
            <div className="max-w-[215px] min-w-[215px] w-full h-14 p-4 font-montserrat font-medium text-sm text-[#4A4A4A] bg-transparent border-[1px] border-[#E8E8E8] border-l-0">
              {data?.team}
            </div>

          </div>
        ))}

        <button
          disabled
          className="flex justify-end items-center w-full mt-4"
        >
          <IconCollection name="plus-icon" />
        </button>
      </div>
    </div>
  );
};


Official.propTypes = {
  officialList: PropTypes.array.isRequired,
};

export default Official;